export default {
  mutations: {
    INCREASE_OFFSET(state: any) {
      state.offset += state.limit;
    },
    DECREASE_OFFSET(state: any) {
      state.offset--;
    },
    CLEAR(state: any) {
      state.list = [];
      state.count = 0;
      state.offset = 0;
    },
    ADD_TO_LIST(state: any, data: any) {
      state.list = [...state.list, ...data];
    },
    SET_COUNT(state: any, data: any) {
      state.count = data;
    },
    REMOVE_FROM_LIST(state: any, id: string) {
      state.list = state.list.filter((el: any) => el.id !== id);
    },
    DECREASE_COUNT(state: any) {
      state.count--;
    },
    REVERSE_LIST(state: any) {
      state.list = state.list.reverse();
    }
  }
};
